import { render } from "./NavLinks.vue?vue&type=template&id=25456b9e&scoped=true"
import script from "./NavLinks.vue?vue&type=script&lang=js"
export * from "./NavLinks.vue?vue&type=script&lang=js"

import "./NavLinks.vue?vue&type=style&index=0&id=25456b9e&lang=scss&scoped=true"

import exportComponent from "/Users/elodie/Desktop/Dev/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25456b9e"]])

export default __exports__